import React from "react";
import { useTranslation } from "react-i18next";
import Statitics from "./Statitics";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function StatiticsSection() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col items-center justify-center mx-auto w-fit">
                <div className="js-scroll fade-top w-[90px] h-[30px]">
                    <img className="w-[100%] h-[100%]" src={require("../../assets/icons/lineMainTitle.svg").default} alt="" />
                </div>
                <div className="js-scroll fade-btm text-[35px] font-bold uppercase text-[#017E89]">{t("Statitics")}</div>
                <span className="js-scroll fade-btm w-[50%] bg-[#017E89] h-[3px]"></span>
            </div>
            <div className="container flex flex-col gap-[15px] items-center text-center py-[20px]">
                <Statitics />
            </div>
        </section>
    );
}